// removed by extract-text-webpack-plugin
module.exports = {"classTextArea":"TextArea-classTextArea-e6fa3dec"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/TextArea.scss
// module id = 905
// module chunks = 0